export default __webpack_public_path__ + "static/media/11.35472d0b.png";